<template>
    <aside
        v-if="isVisible"
        class="machine-translation-notice"
        :class="{ 'machine-translation-notice--expanded': expanded }"
        role="status"
    >
        <button
            type="button"
            class="machine-translation-notice__label"
            :aria-expanded="expanded"
            @click="expanded = !expanded"
        >
            <span aria-hidden="true">文</span>
            {{ $t('machineTranslationNotice.label') }}
        </button>
        <p v-if="expanded" class="machine-translation-notice__message">
            {{ $t('machineTranslationNotice.message') }}
        </p>
        <button
            type="button"
            class="machine-translation-notice__close"
            :aria-label="$t('machineTranslationNotice.close')"
            @click="dismiss"
        >
            &times;
        </button>
    </aside>
</template>

<script>
import { machineTranslationNoticeState, dismissMachineTranslationNotice } from '@/utils/machineTranslationNotice';

export default {
    name: 'MachineTranslationNotice',
    data() {
        return {
            expanded: true,
            noticeState: machineTranslationNoticeState,
        };
    },
    computed: {
        isVisible() {
            const locale = this.$i18n?.locale?.value ?? this.$i18n?.locale;
            return locale !== 'nl' && this.noticeState.detected && !this.noticeState.dismissed;
        },
    },
    methods: {
        dismiss() {
            dismissMachineTranslationNotice();
        },
    },
};
</script>

<style scoped>
.machine-translation-notice {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 950;
    max-width: min(390px, calc(100vw - 48px));
    color: #1d1d1d;
    background: rgba(255, 251, 240, 0.76);
    border: 1px solid rgba(255, 255, 255, 0.68);
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(29, 29, 29, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.5);
    -webkit-backdrop-filter: blur(18px) saturate(135%);
    backdrop-filter: blur(18px) saturate(135%);
}

.machine-translation-notice__label,
.machine-translation-notice__close {
    border: 0;
    color: inherit;
    background: transparent;
    cursor: pointer;
}

.machine-translation-notice__label {
    display: inline-flex;
    gap: 8px;
    align-items: center;
    width: 100%;
    padding: 11px 52px 11px 14px;
    font: inherit;
    font-size: 0.82rem;
    font-weight: 700;
    text-align: left;
}

.machine-translation-notice__close {
    position: absolute;
    top: 7px;
    right: 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.28);
    font-size: 1.25rem;
    line-height: 1;
    transition: background-color 0.18s ease, box-shadow 0.18s ease;
}

.machine-translation-notice__close:hover {
    background: rgba(255, 255, 255, 0.52);
}

.machine-translation-notice__close:focus-visible {
    outline: 2px solid rgba(29, 29, 29, 0.68);
    outline-offset: 2px;
    background: rgba(255, 255, 255, 0.52);
}

.machine-translation-notice__message {
    margin: 0;
    padding: 0 52px 14px 14px;
    font-size: 0.78rem;
    line-height: 1.45;
}

@media (max-width: 600px) {
    .machine-translation-notice {
        right: 12px;
        bottom: 12px;
        left: 12px;
        max-width: none;
    }
}
</style>
